<template>

   <h3>股票优选</h3>

    <!-- 搜索框 -->
    <div class="search-container">
      <el-input
        v-model="questionQuery"
        placeholder="请输入搜索内容"
        @keyup.enter="fetchData"
      />
      <el-button type="primary" @click="fetchData">搜索</el-button>
    </div>

    <div v-if="wencaiData.data">
      <ChildTable :response-data="wencaiData" @fetch-data="fetchData" />
    </div>

</template>

<script>
import ChildTable from '@/components/ChildTable.vue'; // 修改路径
import axios from 'axios';

export default {
  components: {
    ChildTable
  },
  data() {
    return {
      wencaiData: [],
      questionQuery: '', // 搜索查询内容
      isWcSubmitting: false
    };
  },
  methods: {
    async fetchData() {
      if (this.isWcSubmitting) return;
      this.isWcSubmitting = true;
      console.log('开始请求数据:', this.questionQuery);
      try {
        const response = await axios.get(`/api/first_buy`, {
          params: {
            query: this.questionQuery
          }
        });
        const responseData = response.data;
        this.wencaiData = responseData;
        console.log('所有请求完成:', this.wencaiData); // 添加调试信息
      } catch (error) {
        console.error('请求失败:', error);
      } finally {
        this.isWcSubmitting = false;
      }
    }
  },
  mounted() {
    this.fetchData(); // 初始加载数据
  }
};
</script>

<style scoped>
.first-buy-page {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f9f9f9;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5em;
}

.search-container {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-container .el-input {
  width: 300px;
  margin-right: 10px;
}

.search-container .el-button {
  padding: 10px 20px;
}

@media (max-width: 768px) {
  .search-container {
    flex-direction: column;
    align-items: stretch;
  }

  .search-container .el-input {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>
